import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.closeHandler = this.closeOnClickOutside.bind(this)
    this.menuClickHandler = this.closeOnMenuClick.bind(this)
  }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    document.addEventListener("click", this.closeHandler)
    this.menuTarget.addEventListener("click", this.menuClickHandler)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this.closeHandler)
    this.menuTarget.removeEventListener("click", this.menuClickHandler)
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  closeOnMenuClick(event) {
    const clickable = event.target.closest("a, button[type='submit']")
    if (clickable) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener("click", this.closeHandler)
    this.menuTarget.removeEventListener("click", this.menuClickHandler)
  }
}
